import { render } from "./Giveaways.vue?vue&type=template&id=7997c2c1"
import script from "./Giveaways.vue?vue&type=script&lang=js"
export * from "./Giveaways.vue?vue&type=script&lang=js"
script.render = render

export default script